import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { GenericTexts } from './genericTexts';
import { availableLanguages, defaultLocale } from './i18n.config';
import { languages } from '@/shared';

i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		detection: { order: ['cookie', 'localStorage', 'navigator'] },
		resources: {
			en: { translations: GenericTexts[languages.English] },
			es: { translations: GenericTexts[languages.Spanish] },
			ca: { translations: GenericTexts[languages.Catalan] },
			eu: { translations: GenericTexts[languages.Euskera] },
			gl: { translations: GenericTexts[languages.Gallego] },
			de: { translations: GenericTexts[languages.German] },
			fr: { translations: GenericTexts[languages.French] },
			ko: { translations: GenericTexts[languages.Korean] },
			zh: { translations: GenericTexts[languages.Chinese] },
			ja: { translations: GenericTexts[languages.Japanese] },
			pt: { translations: GenericTexts[languages.Portuguese] },
			ru: { translations: GenericTexts[languages.Russian] },
			it: { translations: GenericTexts[languages.Italian] },
			nl: { translations: GenericTexts[languages.Dutch] },
			el: { translations: GenericTexts[languages.Greek] },
		} satisfies Record<(typeof availableLanguages)[number], { translations: unknown }>,
		fallbackLng: defaultLocale,
		debug: false,
		ns: ['translations'],
		defaultNS: 'translations',
		keySeparator: false,
		interpolation: { escapeValue: false },
	});

export { i18n };
